/**
 * Utility Functions
 * Reusable helper functions used throughout the theme
 */

const NCMARaleighUtils = {
  /**
   * Debounce function to limit how often a function is called
   * @param {Function} func - Function to debounce
   * @param {number} wait - Wait time in milliseconds
   * @returns {Function}
   */
  debounce: function(func, wait = 100) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  },

  /**
   * Check if element is visible in viewport
   * @param {HTMLElement} elem - Element to check
   * @returns {boolean}
   */
  isInViewport: function(elem) {
    const bounding = elem.getBoundingClientRect();
    return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  },

  /**
   * Toggle aria-expanded attribute
   * @param {HTMLElement} elem - Element to toggle
   */
  toggleAriaExpanded: function(elem) {
    const expanded = elem.getAttribute('aria-expanded') === 'true';
    elem.setAttribute('aria-expanded', !expanded);
  },

  /**
   * Get breakpoint from CSS variable or return default
   * @returns {Object} Breakpoint values
   */
  getBreakpoints: function() {
    return {
      mobile: 480,
      tablet: 768,
      desktop: 1024
    };
  },

  /**
   * Check current viewport size
   * @returns {string} Current breakpoint name
   */
  getCurrentBreakpoint: function() {
    const width = window.innerWidth;
    const bp = this.getBreakpoints();
    
    if (width < bp.mobile) return 'mobile';
    if (width < bp.tablet) return 'tablet';
    return 'desktop';
  }
};

// Make utilities available globally
window.NCMARaleighUtils = NCMARaleighUtils;
